import { RouteConfig } from 'vue-router'

const FamousTeacherStudioList = () => import('@/views/famous-teacher-studio/StudioList.vue')
const FamousTeacherStudioDetail = () => import('@/views/famous-teacher-studio/StudioDetail.vue')
const FamousTeacherStudioRegist = () => import('@/views/famous-teacher-studio/StudioRegist.vue')

export const famousTeacherStudioListRouter: RouteConfig = {
  path: '/famous-teacher-studio-list',
  name: 'famous_teacher_studio_list',
  component: FamousTeacherStudioList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '名师工作室',
    ignoreLogin: true,
  },
}

export const famousTeacherStudioDetailRouter: RouteConfig = {
  path: '/famous-teacher-studio-detail',
  name: 'famous_teacher_studio_detail',
  component: FamousTeacherStudioDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '名师工作室详情',
    ignoreLogin: true,
  },
}

export const famousTeacherStudioRegistRouter: RouteConfig = {
  path: '/famous-teacher-studio-regist',
  name: 'famous_teacher_studio_regist',
  component: FamousTeacherStudioRegist,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '申请入驻工作室',
    ignoreLogin: true,
  },
}
export default [famousTeacherStudioListRouter, famousTeacherStudioDetailRouter, famousTeacherStudioRegistRouter]
